export default function (Component) {
Component.options.__docs = "<p><code>FdToggle</code> supports <code>v-model</code>. This allows you to bind an <code>FdToggle</code> to a <code>boolean</code> property of your component. The example below uses <code>v-model</code> to control the visbibility of a popover.</p>\n"
}